<template>
  <div class="main">
    <div class="select-container" v-if="!match_id">
      <select name="selected-pool" class="selected-pool" v-model="selectedPool" @change="poolChanged()">
        <option v-for="pool in pools" :value="pool" :key="pool.id">{{ pool.name }}</option>
      </select>
    </div>
    <div class="enter-modal frosted" v-if="enter_modal_visible">
      <div class="top-row">
        <button class="back-button" @click="enter_modal_visible = null;">
        <img src="@/assets/images/back.svg">
      </button>
      <h1 v-if="enter_modal_visible">{{enter_modal_visible === 'add-drink-type' ? 'Drink-Typ hinzufügen' : (enter_modal_visible === 'add-drink' ? 'Getränk hinzufügen' : 'Standards Bearbeiten')}}</h1>
      </div>
      <form v-on:submit.prevent="submitModal" v-if="enter_modal_visible === 'add-drink-type'">
        <label for="new-drink-type-name"><p>Name des Getränketyps</p></label>
        <input type="text" id="new-drink-type-name" v-model="new_drink_type_name">
        <p v-if="modal_msg" class="error">{{modal_msg}}</p>
        <button type="submit"><p>Speichern</p></button>
      </form>
      <form v-on:submit.prevent="submitModal" v-if="enter_modal_visible === 'add-drink'">
        <label for="new-drink-name"><p>Name des Getränks</p></label>
        <input type="text" id="new-drink-name" v-model="new_drink_name">
        <label for="new-drink-default-ml"><p>Standard-ml</p></label>
        <input type="number" id="new-drink-default-ml" v-model="new_drink_default_ml">
        
        <div class="preset-buttons">
          <button type="button" @click="new_drink_default_ml = 20">20ml</button>
          <button type="button" @click="new_drink_default_ml = 40">40ml</button>
          <button type="button" @click="new_drink_default_ml = 100">100ml</button>
          <button type="button" @click="new_drink_default_ml = 200">200ml</button>
          <button type="button" @click="new_drink_default_ml = 330">330ml</button>
          <button type="button" @click="new_drink_default_ml = 500">500ml</button>
          <button type="button" @click="new_drink_default_ml = 750">750ml</button>
          <button type="button" @click="new_drink_default_ml = 1000">1000ml</button>
        </div>

        <label for="new-drink-default-vol"><p>Standard-vol%</p></label>
        <input type="number" step="0.1" inputmode="decimal" id="new-drink-default-vol" v-model="new_drink_default_vol">
        <p v-if="modal_msg" class="error">{{modal_msg}}</p>
        <p v-if="soft_limit_warning" class="warning-text" v-html="soft_limit_warning"></p>
        <button type="submit"><p>Speichern</p></button>
      </form>
      <form v-on:submit.prevent="submitModal" v-if="enter_modal_visible === 'edit-drink'">
        <label for="new-drink-name"><p>Name des Getränks</p></label>
        <input type="text" id="new-drink-name" v-model="selected_drink.drink_name">
        <label for="new-drink-default-ml"><p>Standard-ml</p></label>
        <input type="number" id="new-drink-default-ml" v-model="selected_drink.drink_default_ml">
        <label for="new-drink-default-vol"><p>Standard-vol%</p></label>
        <input type="number" step="0.1" inputmode="decimal" id="new-drink-default-vol" v-model="selected_drink.drink_default_vol">
        <p v-if="modal_msg" class="error">{{modal_msg}}</p>
        <div class="button-row">
           <button type="button" class="delete-btn-inside" @click="enter_modal_visible = 'delete-drink-confirm'">Löschen</button>
           <button type="submit">Speichern</button>
        </div>
      </form>

    </div>
    <div class="headline-container" v-if="!enter_modal_visible" :class="{space_between: !!selected_drink_type}">
      <button class="back-button" v-if="selected_drink_type" @click="selectDrinkType(null)">
        <img src="@/assets/images/back.svg">
      </button>
      <h1>{{selected_drink_type?.drink_type_name ?? 'Drink-Typen'}} </h1>
      <button class="delete-category-button" v-if="selected_drink_type" @click="openModal('delete-category')">
        <img src="@/assets/images/delete.svg">
      </button>
      <button class="back-button" v-if="!selected_drink_type" style="opacity: 0;">
        <img src="@/assets/images/back.svg">
      </button>
    </div>

    <!-- Confirmation Modals -->
    <div class="enter-modal frosted delete-modal" v-if="enter_modal_visible === 'delete-category'">
      <h2>Kategorie löschen?</h2>
      <p>Willst du die Kategorie "{{selected_drink_type.drink_type_name}}" wirklich löschen?</p>
      <p class="hint">Das geht nur, wenn keine Getränke mehr darin sind.</p>
      <p v-if="modal_msg" class="error">{{modal_msg}}</p>
      <div class="button-row">
        <button class="cancel-button" @click="enter_modal_visible = false">Abbrechen</button>
        <button class="confirm-delete-button" @click="confirmDeleteCategory" :disabled="loading">Löschen</button>
      </div>
    </div>

    <div class="enter-modal frosted delete-modal" v-if="enter_modal_visible === 'delete-drink-confirm'">
      <h2>Getränk löschen?</h2>
      <p>Willst du "{{selected_drink.drink_name}}" wirklich löschen?</p>
      <p class="hint">Das geht nur, wenn noch kein Schluck davon getrunken wurde (keine Historie).</p>
      <p v-if="modal_msg" class="error">{{modal_msg}}</p>
      <div class="button-row">
        <button class="cancel-button" @click="enter_modal_visible = 'edit-drink'">Abbrechen</button>
        <button class="confirm-delete-button" @click="confirmDeleteDrink" :disabled="loading">Löschen</button>
      </div>
    </div>

    <div v-if="!loading && (!this.pools || this.pools.length === 0) && !enter_modal_visible" class="center-msg">
      <h3>Du bist noch kein Mitglied in einer Gruppe!</h3>
      <p>Tritt auf der Startseite zuerst einer Gruppe bei.</p>
    </div>
    <div class="drink-type-list" v-if="!loading && !enter_modal_visible && !selected_drink_type">
      <button class="single-drink-type frosted" v-for="drink_type in drink_types" :key="drink_type.drink_type_id" @click="selectDrinkType(drink_type)">
        <div class="drink-type-name">
          <img src="@/assets/images/beer.svg" v-if="drink_type.drink_type_name === 'Bier'">
          <img src="@/assets/images/wine.svg" v-if="drink_type.drink_type_name === 'Wein'">
          <img src="@/assets/images/drink.svg" v-if="drink_type.drink_type_name !== 'Wein' && drink_type.drink_type_name !== 'Bier'">
          <h2>{{drink_type.drink_type_name}}</h2>
        </div>
          <div class="drink-stats">
            <p><b>{{drink_type.count}}</b> {{drink_type.count === 1 ? 'hinterlegtes Getränk' : 'hinterlegte Getränke'}}</p>
          </div>
      </button>
      <button class="add-drink-type-button" @click="openModal('add-drink-type')" v-if="!loading && (this.pools && this.pools.length > 0)">
        <h2>Typ hinzufügen</h2>
      </button>
    </div>

    <div class="drink-type-list" v-if="!loading && (this.drinks) && !enter_modal_visible && selected_drink_type">
      <div class="single-drink frosted" v-if="drinks.length === 0" style="background: none;">
        <h2>Hier ist noch kein Drink zum Dumm gehen :(</h2>
      </div>
      <button class="single-drink frosted" v-for="drink in drinks" :key="drink.drink_id" @click="selectDrink(drink)">
        <div class="drink-name">
          <h2>{{drink.drink_name}}</h2>
        </div>
        <div class="drink-stats">
          <h4>Standards</h4>
          <p><b>{{drink.drink_default_vol.toString().replace('.', ',')}}</b> %vol</p>
          <p><b>{{drink.drink_default_ml}}</b> ml</p>
        </div>
      </button>
      <button class="add-drink-type-button" @click="openModal('add-drink')">
        <h2>Drink hinzufügen</h2>
      </button>
    </div>
    <LoadingSpinner  v-if="loading" message="Drinks werden geladen..." class="center-msg"/>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService.js';
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import moment from 'moment';
import registerPushWorker, { requestPushPermission } from '@/registerServiceWorker';
export default {
  "name": "DrinksView",
  components: {LoadingSpinner},
  data() {
    return {
      isAdmin: false,
      pools: null,
      drinks: null,
      drink_types: null,
      loading: false,
      push_activated: true,
      enter_modal_visible: false,
      modal_msg: null,
      selected_drink_type: null,
      new_drink_type_name: null,
      new_drink_name: null,
      new_drink_default_ml: null,
      new_drink_default_vol: null,
      selected_drink: null,
      soft_limit_warning: null,
    }
  },
  computed: {
    selectedPool: {
      get() {
        return this.$store.getters.getSelectedPool;
      },
      set(val) {
        this.$store.commit('SET_SELECTED_POOL', val);
      }
    },
    drink_id() {
      return this.$route.query.drink
    },
    user_id() {
      return this.$store.getters.getUser.id
    }
  },
  watch:{
    $route (){
      this.setup();
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
    async onRequestPermissionClick() {
      const permission = Notification.permission;

      if (permission === 'default') {
        // ✅ Diese Zeile MUSS direkt im Click-Handler passieren!
        const result = await Notification.requestPermission();
        if (result !== 'granted') {
          console.warn('❌ Berechtigung nicht erteilt.');
          return;
        }
      } else if (permission !== 'granted') {
        console.warn('❌ Berechtigung bereits verweigert.');
        return;
      }

      // Jetzt sicher: Berechtigung ist erteilt
      await registerPushWorker();
    },
    async requestPushPermission(){
      // iOS-optimierte Push-Permission-Anfrage
      await requestPushPermission();
    },
    async getAvailableDrinkTypes(){
      this.loading = true
      if(this.selectedPool?.pool_id) {
        let msg = await AuthService.getAvailableDrinkTypes({pool_id: this.selectedPool.pool_id});
        if(msg.success) {
          this.drink_types = msg.msg
        }
      }
      this.loading = false
    },
    openModal(type) {
      this.enter_modal_visible = type;
      this.soft_limit_warning = null;
      this.modal_msg = null;
    },
    async submitModal() {
      if(this.enter_modal_visible === 'add-drink-type') {
        if(this.new_drink_type_name.length < 3) {
          this.modal_msg = "Der Name des Drink-Typs muss mindestens 3 Zeichen lang sein!"
        } else {
          try {
            let response = await AuthService.addNewDrinkType({pool_id: this.selectedPool.pool_id, drink_type_name: this.new_drink_type_name});
            if(response.success) {
              this.$router.go()
            } else {
              this.modal_msg = response.msg
            }
          } catch(e) {
            this.modal_msg = e.response?.data?.msg || e.message || "Es ist ein Fehler aufgetreten.";
          }
        }
      } else if (this.enter_modal_visible === 'add-drink') {
        const ml = parseFloat(this.new_drink_default_ml) || 0;
        const volStr = String(this.new_drink_default_vol || '0').replace(',', '.');
        const vol = parseFloat(volStr) || 0;

        if(this.new_drink_name.length < 3) {
          this.modal_msg = "Der Name des Drinks muss mindestens 3 Zeichen lang sein!"
        } else if (ml <= 0) {
          this.modal_msg = "Menge (ml) muss größer als 0 sein."
        } else if (ml > 3000) {
          this.modal_msg = "Maximal 3.000 ml auf einmal möglich!"
        } else if (vol < 0) {
          this.modal_msg = "Alkoholgehalt darf nicht negativ sein."
        } else if (vol > 100) {
          this.modal_msg = "Sicher dass das mehr als 100% ist? Ich glaube nicht."
          this.soft_limit_warning = null;
        } else {
          // Soft-Maximum warnings check
          if (!this.soft_limit_warning) {
            if (ml > 1500) {
              this.soft_limit_warning = `<b>Sicher, dass du ${ml}ml eintragen willst?</b><br>Das ist mehr als 1.5 Liter! Klicke nochmal auf Speichern zum Bestätigen.`;
              this.modal_msg = null;
              return;
            }
            if (vol > 96) {
               this.soft_limit_warning = `<b>Höllenmaschine am Start?</b><br>${vol}% Vol ist extrem hoch. Sicher? Klicke nochmal auf Speichern zum Bestätigen.`;
               this.modal_msg = null;
               return;
            }
          }

          try {
            let response = await AuthService.addNewDrink(
                {pool_id: this.selectedPool.pool_id,
                      drink_name: this.new_drink_name,
                      drink_type_id: this.selected_drink_type.drink_type_id,
                      default_ml: ml,
                      default_vol: vol
                })
            ;
            if(response.success) {
              this.$router.go()
            } else {
              this.modal_msg = response.msg
            }
          } catch(e) {
            this.modal_msg = e.response?.data?.msg || e.message || "Es ist ein Fehler aufgetreten.";
          }
        }
      } else if (this.enter_modal_visible === 'edit-drink') {
        if(this.selected_drink.drink_name.length < 3) {
          this.modal_msg = "Der Name des Drinks muss mindestens 3 Zeichen lang sein!"
        } else {
          try {
            let response = await AuthService.updateDrink(
                {pool_id: this.selectedPool.pool_id,
                  drink_id: this.selected_drink.drink_id,
                  drink_name: this.selected_drink.drink_name,
                  default_ml: this.selected_drink.drink_default_ml,
                  default_vol: this.selected_drink.drink_default_vol.toString().replace(',','.'),
                })
            ;
            if(response.success) {
              this.$router.go()
            } else {
              this.modal_msg = response.msg
            }
          } catch(e) {
            console.error(e)
            this.modal_msg = e.response?.data?.msg || e.message || "Es ist ein Fehler aufgetreten.";
          }
        }
      }
    },
    async confirmDeleteCategory() {
      this.loading = true;
      try {
        let response = await AuthService.deleteDrinkType({
          pool_id: this.selectedPool.pool_id,
          drink_type_id: this.selected_drink_type.drink_type_id
        });
        if(response.success) {
          this.$router.go();
        } else {
          this.modal_msg = response.msg;
        }
      } catch(e) {
        this.modal_msg = e.response?.data?.msg || "Fehler beim Löschen.";
      }
      this.loading = false;
    },
    async confirmDeleteDrink() {
      this.loading = true;
      try {
        let response = await AuthService.deleteDrink({
          pool_id: this.selectedPool.pool_id,
          drink_id: this.selected_drink.drink_id
        });
        if(response.success) {
          this.$router.go();
        } else {
          this.modal_msg = response.msg;
        }
      } catch(e) {
        this.modal_msg = e.response?.data?.msg || "Fehler beim Löschen.";
      }
      this.loading = false;
    },

    selectDrinkType(id){
      this.selected_drink_type = id;
      if(id == null) {
        this.drinks = null
      } else {
        this.getDrinksOfSelectedType()
      }
    },
    selectDrink(drink){
      this.selected_drink = drink
      this.enter_modal_visible = "edit-drink"
    },
    async getDrinksOfSelectedType() {
      try {
        let response = await AuthService.getAvailableDrinksOfType({pool_id: this.selectedPool.pool_id, drink_type_id: this.selected_drink_type.drink_type_id});
        if(response.success) {
          this.drinks = response.msg.sort((a, b) => a.drink_name.localeCompare(b.drink_name));
        } else {
          this.modal_msg = response.msg
        }
      } catch(e) {
        console.error(e)
        this.modal_msg = e.response?.data?.msg || e.message || "Es ist ein Fehler aufgetreten.";
      }
    },
    async getUserJoinedPools() {
      this.loading = true
      try {
        this.msg = await AuthService.getUserJoinedPools()
        if (this.msg.success && this.msg.msg.length > 0) {
          this.pools = this.msg.msg

          // Check if previously selected pool is still available
          const persistedPool = this.selectedPool;
          if (persistedPool) {
            const persistedId = persistedPool.pool_id || persistedPool.id;
            const found = this.pools.find(p => (p.pool_id || p.id) === persistedId);
            if (found) {
              this.selectedPool = found;
              return;
            }
          }

          // Fallback to first pool if none selected or not found
          this.selectedPool = this.msg.msg[0]
        }
      } catch (e) {
        console.error(e)
        this.errorMsg = e.response.data.msg
      }
      this.loading = false
    },
    async loadChat() {
      if(this.match_id) {
        let msg = await AuthService.getChat({match_id: this.match_id});
        if(msg.success) {
          this.chat = {
            name: msg.match,
            messages: msg.msg.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp)).map(m => { return {...m, timestamp: moment(m.timestamp).format("HH:mm")} }),
          }

          this.message = (msg.msg.length === 0 ? "Noch keine Nachrichten." : null)

          this.$nextTick(() => { //scroll to bottom after the message wrapper is rendered
            let chatDiv = document.getElementById("message-wrapper")
            chatDiv.scrollTop = chatDiv.scrollHeight;
          });
        }
      } else {
        this.chat = null
      }
    },
    async sendMessage() {
      let msg = {
        message_id: 1,
        match_id: this.match_id,
        author_id: this.$store.getters.getUser.id,
        timestamp: moment().format("HH:mm"),
        content: this.newMessage,
        status: "sending"
      }

      this.chat.messages.push(msg)

      let res = await AuthService.sendChat(msg)
      console.log(res)
      this.newMessage = null
      this.message = null;
      this.$nextTick(() => { //scroll to bottom after the message wrapper is rendered
        let chatDiv = document.getElementById("message-wrapper")
        chatDiv.scrollTop = chatDiv.scrollHeight;
      });
    },
    calcDurationToNow(date){
      return date ? (moment(date).isSame(moment(), 'day') ? moment(date).format("HH:mm") : (moment().diff(moment(date), 'hours') > 24 ? moment().diff(moment(date), 'days') + " Tage" : moment().diff(moment(date), 'hours') + " Stunden")) : ""
    },
    async setup () {
      await this.getUserJoinedPools();
      await this.getAvailableDrinkTypes()
    },
    async poolChanged() {
      await this.getAvailableDrinkTypes()
    }
  },
  async beforeCreate() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/login');
    }
  },
  async mounted() {
    try {
      this.msg = await AuthService.getUser()
      this.isAdmin = !!this.msg.msg.isAdmin;
    } catch(e){
      console.error(e)
    }

    AuthService.getPushActivationStatus().then(result => {
      if(result.success){
        this.push_activated = result.msg
      }
    })

    await this.setup()
  }
}
</script>
<style scoped>
@view-transition {
  navigation: auto;
}

.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  background: var(--background);
  padding: 20px;
}

h1 {
  font-size: 1.8rem;
  margin: 0;
  text-align: center;
  width: 100%;
}

h2 {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
}

h3 {
  margin: 20px 0 10px 0;
}

p {
  color: var(--tertiary-color);
  margin: 0;
}

/* Select Pool Header */
.select-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  max-width: 600px;
  margin-bottom: 20px;
  padding: 10px 0;
}

.selected-pool {
  font-size: 1.5rem;
  font-family: var(--font);
  font-weight: 700;
  background: none;
  border: none;
  color: var(--primary-color);
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  text-align: center;
  text-align-last: center;
}

.select-container img {
  transform: rotate(-90deg);
  width: 16px;
  height: 16px;
  opacity: 0.5;
}

/* Lists */
.drink-type-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 600px;
  overflow-y: auto;
  padding-bottom: 100px; /* Space for footer */
}

.single-drink-type, .single-drink {
  background: var(--background-secondary);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  width: 100%;
  box-sizing: border-box;
  min-height: 70px;
  border-radius: var(--radius-m);
  padding: 15px 20px;
  border: none;
  transition: transform 0.1s, background 0.2s;
}

.single-drink-type:active, .single-drink:active {
  transform: scale(0.98);
  background: var(--active-bg);
}

.single-drink-type .drink-type-name, .drink-name {
  display: flex;
  align-items: center;
  gap: 15px;
  text-align: left;
}

.single-drink-type img {
  width: 32px;
  height: 32px;
  filter: var(--icon-filter);
  opacity: 0.8;
}

.add-drink-type-button {
  background: transparent;
  color: var(--primary-color);
  border: 2px dashed var(--border-color);
  padding: 20px;
  border-radius: var(--radius-m);
  margin-top: 10px;
  width: 100%;
}

.add-drink-type-button h2 {
  opacity: 0.5;
}

.drink-stats {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
}

.drink-stats p, .drink-stats h4 {
  font-size: 0.9rem;
  margin: 0;
}

.drink-stats b {
  color: var(--primary-color);
}

/* Modal */
.enter-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: var(--background);
  width: 90%;
  max-width: 400px;
  border-radius: var(--radius-l);
  padding: 30px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.15); /* Strong shadow for modal */
  z-index: 2000;
  display: flex;
  flex-direction: column;
  gap: 20px;
  border: 1px solid var(--border-color);
  box-sizing: border-box;
}

.enter-modal .top-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0;
}

.enter-modal .top-row .back-button {
  padding: 0;
}

.enter-modal h1 {
  font-size: 1.5rem;
  margin: 0;
  text-align: left;
  white-space: nowrap;
}

.enter-modal form {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.enter-modal label p {
  font-weight: 500;
  color: var(--primary-color);
  margin-bottom: 5px;
  text-align: left;
}

.enter-modal input {
  font-size: 1.1rem;
  padding: 12px;
  margin-bottom: 10px;
  background: var(--background-secondary);
  border: none;
  border-radius: var(--radius-s);
  color: var(--primary-color);
  width: 100%;
  box-sizing: border-box;
}

.enter-modal button[type=submit] {
  background: var(--primary-color);
  color: var(--text-on-primary);
  padding: 15px;
  border-radius: var(--radius-m);
  font-size: 1.1rem;
  font-weight: 600;
  margin-top: 10px;
  width: 100%;
}

.enter-modal button[type=submit] p {
  color: var(--background);
}

/* Header & Nav */
.headline-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 600px;
  margin-bottom: 20px;
}

.headline-container h1 {
  font-size: 1.8rem;
  text-align: center;
}

.back-button {
  background: none;
  border: none;
  padding: 10px;
  margin-left: -10px;
  display: flex;
  align-items: center;
}

.back-button img {
  width: 24px;
  height: 24px;
  filter: var(--icon-filter);
}

.center-msg {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 50vh;
  text-align: center;
  margin-top: 0;
}

.warning-text {
  color: #f44336; /* Red color for warning */
  font-weight: bold;
  font-size: 0.9rem;
  margin-top: -10px;
  margin-bottom: 5px;
  text-align: center;
}

.preset-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.preset-buttons button {
  background: var(--background-secondary);
  border: 1px solid var(--border-color);
  color: var(--primary-color);
  padding: 8px 12px;
  border-radius: var(--radius-s);
  font-size: 0.9rem;
  flex: 1 0 calc(25% - 8px); /* 4 items per row minus gap */
  cursor: pointer;
  transition: transform 0.1s, background 0.2s;
}

.preset-buttons button:active {
  transform: scale(0.95);
  background: var(--active-bg);
}

.delete-category-button {
  background: none;
  border: none;
  padding: 10px;
  margin-right: -10px;
  display: flex;
  align-items: center;
}

.delete-category-button img {
  width: 24px;
  height: 24px;
  filter: var(--icon-filter);
  opacity: 0.5;
}

.button-row {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.button-row button {
  flex: 1;
  padding: 15px;
  border-radius: var(--radius-m);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
}

.cancel-button {
  background: var(--background-secondary);
  color: var(--primary-color);
}

.confirm-delete-button {
  background: var(--warning);
  color: #FFF;
}

.delete-btn-inside {
  background: var(--background-secondary) !important;
  color: var(--warning) !important;
}

.delete-modal h2 {
  text-align: center;
  margin-bottom: 10px;
}

.delete-modal p {
  text-align: center;
}

.hint {
  font-size: 0.8rem;
  opacity: 0.7;
  margin-top: 5px;
}

.error {
  color: var(--warning);
  text-align: center;
  font-size: 0.9rem;
}
</style>

